import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Landing as ShellLanding, CtaButton } from '@ofself/shell';
import './Landing.css';

// NUCLEUS'S FRONT DOOR — the shell's <Landing> surface template, as Ink and
// Missions mount it: the field, the Phyllo mark drawing itself (no `mark`
// passed: the shell draws the register's own figure for currentApp), the
// NUCLEUS·OFSELF wordmark, one action. Nucleus is where an ofSelf account
// lives, so the way in is our own /login, not an OAuth round-trip.
//
// This renders unauthenticated: every line must be true of the product today.

function Landing() {
  const navigate = useNavigate();
  // Plain clicks stay in the SPA; modified clicks open the href as a link.
  const go = (to) => (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };

  return (
    <ShellLanding
      currentApp="nucleus"
      wordmark="NUCLEUS"
      bottomRight="Your identity, and who may see it."
      cta={(
        <div className="nucleus-landing__cta">
          <CtaButton href="/login" onClick={go('/login')}>Sign in</CtaButton>
          <a className="nucleus-landing__join" href="/register" onClick={go('/register')}>
            New to ofSelf? Create an account
          </a>
        </div>
      )}
    />
  );
}

export default Landing;
